import {
  FlowPatientDataStoreCaseSensitivity,
  FlowPatientDataStoreFilterMatchRule,
  FlowPatientDataStoreFilterOperator,
} from 'flow-schema';

export const FILTER_BLOCK_OPERATOR_NAMES: Record<
  keyof typeof FlowPatientDataStoreFilterOperator,
  string
> = {
  [FlowPatientDataStoreFilterOperator.Equals]: 'equals',
  [FlowPatientDataStoreFilterOperator.NotEquals]: 'does not equal',
  [FlowPatientDataStoreFilterOperator.Contains]: 'contains',
  [FlowPatientDataStoreFilterOperator.DoesNotContain]: 'does not contain',
  [FlowPatientDataStoreFilterOperator.GreaterThan]: 'is greater than',
  [FlowPatientDataStoreFilterOperator.GreaterThanOrEqualTo]: 'is greater than or equal to',
  [FlowPatientDataStoreFilterOperator.LessThan]: 'is less than',
  [FlowPatientDataStoreFilterOperator.LessThanOrEqualTo]: 'is less than or equal to',
  [FlowPatientDataStoreFilterOperator.IsOneOf]: 'is one of',
  [FlowPatientDataStoreFilterOperator.IsNotOneOf]: 'is not one of',
  [FlowPatientDataStoreFilterOperator.StartsWith]: 'starts with',
  [FlowPatientDataStoreFilterOperator.EndsWith]: 'ends with',
  [FlowPatientDataStoreFilterOperator.IsEmpty]: 'is empty',
  [FlowPatientDataStoreFilterOperator.IsNotEmpty]: 'is not empty',
};

export const FILTER_BLOCK_CASE_SENSITIVITY_NAMES: Record<
  keyof typeof FlowPatientDataStoreCaseSensitivity,
  string
> = {
  [FlowPatientDataStoreCaseSensitivity.ExactMatch]: 'Exact Match',
  [FlowPatientDataStoreCaseSensitivity.IgnoreCase]: 'Ignore Case',
};

export const FILTER_OPERATORS_NEED_CASE_SENSITIVITY = [
  FlowPatientDataStoreFilterOperator.Equals,
  FlowPatientDataStoreFilterOperator.NotEquals,
  FlowPatientDataStoreFilterOperator.Contains,
  FlowPatientDataStoreFilterOperator.DoesNotContain,
  FlowPatientDataStoreFilterOperator.StartsWith,
  FlowPatientDataStoreFilterOperator.EndsWith,
  FlowPatientDataStoreFilterOperator.IsOneOf,
  FlowPatientDataStoreFilterOperator.IsNotOneOf,
];

export const FILTER_BLOCK_MATCH_RULE_NAMES: Record<
  keyof typeof FlowPatientDataStoreFilterMatchRule,
  string
> = {
  [FlowPatientDataStoreFilterMatchRule.All]: 'all',
  [FlowPatientDataStoreFilterMatchRule.Any]: 'any',
};

export const FILTER_BLOCK_NULL_OPERATORS = [
  FlowPatientDataStoreFilterOperator.IsEmpty,
  FlowPatientDataStoreFilterOperator.IsNotEmpty,
];
